import {maxNumberOfFeatureType} from '../../../../libs/shared/core/src/helpers/models/billingHelpers';
import {createSelector} from '../../../../srcCommon/helpers/reselectHelpers';
import {getCompany} from '../../../store/data/company/companySelectors';
import {
  AnalyticsPanelIdSelector,
  getDefaultAnalyticsPanelId,
} from '../../../store/panels/analytics/analyticsPanelSelectors';
import {
  makeGetAnalyticsReportType,
  makeGetAnalyticsSelectedNamespace,
  makeGetAnalyticsSelectedViewId,
} from '../../../store/panels/analytics/parameters/analyticsPanelParametersSelectors';
import {
  AnalyticsSelectedViewId,
  isAnalyticsViewSaved,
  isAnalyticsViewTemporary,
  isSelectedViewAllData,
} from '../../../store/panels/analytics/views/analyticsPanelViewsState';

enum AnalyticsViewsEnum {
  ALL_DATA = 'all_data',
  SAVED_VIEW = 'saved_view',
  TEMP_VIEW = 'temp_view',
}

function getViewType(viewId: AnalyticsSelectedViewId | string): AnalyticsViewsEnum {
  if (isAnalyticsViewTemporary(viewId)) {
    return AnalyticsViewsEnum.TEMP_VIEW;
  }
  if (isSelectedViewAllData(viewId)) {
    return AnalyticsViewsEnum.ALL_DATA;
  }
  return AnalyticsViewsEnum.SAVED_VIEW;
}

export function serializeSavedViewId(viewId: AnalyticsSelectedViewId | string) {
  return {
    view_type: getViewType(viewId),
    saved_view_id: isAnalyticsViewSaved(viewId) ? viewId : null,
  };
}

export function makeGetAnalyticsTrackingData<P = void>(getPanelId: AnalyticsPanelIdSelector<P>) {
  const getReportType = makeGetAnalyticsReportType(getPanelId);
  const getSelectedViewId = makeGetAnalyticsSelectedViewId(getPanelId);
  const getSelectedNamespace = makeGetAnalyticsSelectedNamespace(getPanelId);

  return createSelector(
    [getReportType, getSelectedViewId, getSelectedNamespace],
    (reportType, viewId, namespace) => ({
      report_type: reportType,
      ...serializeSavedViewId(viewId),
      namespace,
    }),
  );
}

export const getAnalyticsTrackingData = makeGetAnalyticsTrackingData(getDefaultAnalyticsPanelId);

export const getMaxNumAnalyticsRetentionDays = createSelector([getCompany], (company) =>
  maxNumberOfFeatureType('analytics_retention', company.features, 0),
);
